export default __webpack_public_path__ + "static/media/modcloth.png.webp";